import Button from "@material-ui/core/Button";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import React from "react";
import { WidgetProps } from "./models";

const styles = (theme: Theme) =>
  createStyles({
    display: {
      display: "flex",
      flexDirection: "row",
      color: theme.palette.text.primary,
      marginTop: theme.spacing(2),
      padding: "7px 0 9px",
    },
    revisionNumber: {},
    pastVersionsButton: {
      marginTop: -7,
      marginLeft: 9,
    },
  });

interface VersionedEventRevisionNumberWidgetReadOnlyOptions {
  showButton?: boolean;
}

interface VersionedEventRevisionNumberReadOnlyWidgetProps extends WidgetProps<number>, WithStyles<typeof styles> {
  options: VersionedEventRevisionNumberWidgetReadOnlyOptions;
}

export const VersionedEventRevisionNumberReadOnlyWidgetComponent = (
  props: VersionedEventRevisionNumberReadOnlyWidgetProps,
) => {
  const { classes, formContext, value, options } = props;

  const onViewPastVersionClick = () => {
    const { onFormFieldAction } = formContext;

    if (onFormFieldAction) {
      onFormFieldAction("view-past-versions");
    }
  };

  return (
    <div className={classes.display}>
      <div className={classes.revisionNumber}>{value}</div>
      {options.showButton && value > 1 ? (
        <Button color="secondary" className={classes.pastVersionsButton} onClick={onViewPastVersionClick}>
          View Past Versions
        </Button>
      ) : null}
    </div>
  );
};

export const VersionedEventRevisionNumberReadOnlyWidget = withStyles(styles)(
  VersionedEventRevisionNumberReadOnlyWidgetComponent,
);
